import React from 'react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
export function Author() {
  return <Section data-id="element-57" data-mp="1htc6d8h2jhh9">
      <Eyebrow data-id="element-58" data-mp="1hpo9q0gbueyb">From the workshop</Eyebrow>
      <Heading data-id="element-59" data-mp="1wh6zgpyznnuv">Why we created Weld Decision System™</Heading>

      <figure className="mt-8" data-id="element-60" data-mp="1wirt8ddhb2ro">
        <img src="https://cdn.magicpatterns.com/uploads/3GLAC7A1ceS5Msn8wJSt4J/Juan_Escamilla_Soldador.jpg" alt="Juan Escamilla, creator of the Weld Decision System, in a professional welding workshop" className="w-full rounded-2xl border border-ink-600 object-cover" width={928} height={1160} loading="lazy" data-id="element-61" data-mp="1rpf5e5gmizzz" />
        <figcaption className="mt-3 text-center text-[13px] font-semibold uppercase tracking-[0.14em] text-zinc-500" data-id="element-62" data-mp="2aggehmbgkbx9">
          Juan Escamilla · Creator of Weld Decision System™
        </figcaption>
      </figure>

      <div className="mt-7 space-y-4 text-[15px] leading-relaxed text-zinc-300" data-id="element-63" data-mp="g2ow9yf2cjq7">
        <p data-id="element-64" data-mp="g4rs4z2wd72u">
          Most welders don’t struggle because they lack the ability to learn. They struggle because
          when something goes wrong, they don’t have a clear process for figuring out what to check
          next.
        </p>
        <p data-id="element-65" data-mp="3pdzs6ctcjsze">
          They watch scattered videos. One welder recommends one approach. Another recommends
          something completely different. They change a setting. Then another. They try again. The
          weld still doesn’t look right.
        </p>
        <p className="rounded-xl border border-ink-600 bg-ink-800 px-4 py-3 text-center font-display text-lg font-extrabold uppercase leading-tight tracking-wide text-ember" data-id="element-66" data-mp="31sw4ue1kq6i">
          Guess → Try → Fail → Change → Try again
        </p>
        <p data-id="element-67" data-mp="gzhftywdhr9z">
          That’s exactly why I created Weld Decision System™. I’m Juan Escamilla, and I wanted
          something different from another long welding course or another collection of
          disconnected videos. I wanted a practical system you could actually consult while you’re
          working — something that answers the question:
        </p>
        <p className="text-center font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-68" data-mp="3h2ewp2w3j1ib">
          “What should I check next?”
        </p>
        <p className="rounded-xl border border-flame-500/40 bg-flame-500/10 px-4 py-3 text-center font-display text-lg font-extrabold uppercase leading-tight tracking-wide text-spark" data-id="element-69" data-mp="3v3rcneb9b347">
          Prepare → Set → Weld → Check → Correct
        </p>
        <p data-id="element-70" data-mp="3vwob7m6ar1l">So instead of improvising your next move, you have a system to guide it.</p>
        <p className="font-display text-xl font-extrabold uppercase leading-tight text-white" data-id="element-71" data-mp="3u2cqjwskba6">
          Stop guessing what to do next. Start following a clear process.
        </p>
        <p className="text-sm font-semibold text-zinc-400" data-id="element-72" data-mp="dmhtxf09kvu0">— Juan Escamilla</p>
      </div>

      <div className="mt-8" data-id="element-73" data-mp="rlzgrou01z0q">
        <CTAButton data-id="element-74" data-mp="mmeep5jj9ajs" />
      </div>
    </Section>;
}